import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { NoticeBar } from "@/components/NoticeBar";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { HowToOrder } from "@/components/HowToOrder";
import { PartyCombos } from "@/components/PartyCombos";
import { Extras } from "@/components/Extras";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { BackToTop } from "@/components/BackToTop";
import { SAVOURY, SWEET } from "@/data/menu";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const hash = anchor.getAttribute("href");
      if (!hash || hash.length < 2) return;
      const el = document.querySelector(hash);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -76, duration: 1.3 });
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App bg-brand-bg font-sans text-brand-dark">
      <Header />
      <main>
        <Hero />
        <NoticeBar />
        <Marquee />
        <About />
        <HowToOrder />
        <PartyCombos />
        <Extras
          id="extras"
          alt
          chapter="04"
          chapterLabel="ДОПЪЛНИТЕЛНИ ПРЕДЛОЖЕНИЯ"
          title="ДОБАВЕТЕ ОЩЕ КЪМ ВАШАТА PARTY КОМБИНАЦИЯ"
          intro={[
            "Искате повече от любимите си хапки?",
            "Към PARTY 10, PARTY 15 или PARTY 20 можете да добавите допълнително плато от избраните предложения.",
          ]}
          note="Допълнителните предложения се заявяват само към избрана PARTY комбинация и са във фиксирано количество от 20 броя."
          items={SAVOURY}
          testIdPrefix="extras"
        />
        <Extras
          id="sweet"
          chapter="05"
          chapterLabel="СЛАДКИ ПРЕДЛОЖЕНИЯ"
          title="ДОБАВЕТЕ НЕЩО СЛАДКО"
          intro={["Допълнете избраната PARTY комбинация със сладко плато по избор."]}
          note="Сладките предложения се заявяват като плато от един вид във фиксирано количество от 20 броя и се добавят към избрана PARTY комбинация."
          items={SWEET}
          testIdPrefix="sweet"
          gridClass="sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
        />
        <FinalCTA />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;
